import React from 'react'

import styles from './SprintStatCard.module.css'

const SprintStatCard = ({ label, value, caption = 'work items', tone }) => {
    const toneClass =
        tone === 'warning'
            ? styles.cardWarning
            : tone === 'success'
              ? styles.cardSuccess
              : ''

    return (
        <div className={`${styles.card} ${toneClass}`}>
            <span className={styles.label}>{label}</span>
            <span className={styles.value}>{value}</span>
            <span className={styles.caption}>{caption}</span>
        </div>
    )
}

export default SprintStatCard

